var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){return _vm.$emit('lmBtnUpdateContentClick')}}},[_c('i',{staticClass:"mdi mdi-autorenew",class:{'lm-rotate': _vm.loading}})])}
var staticRenderFns = []

export { render, staticRenderFns }